// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"0bae4a5a","496":"8d0734d8"}[chunkId] + ".chunk.js";
};